export default __webpack_public_path__ + "static/media/027-motorcycle.2fd9e6b7.svg";